module.exports = __webpack_public_path__ + "static/media/phase1done.dd97d39d.png";